module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/texas-tech-6d11c3cfbdebd49814273d7722bf42fb.svg";